// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-loader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.chartkit-loader_veil {
  background-color: var(--ck-veil-background);
}
.chartkit-loader__loader_compact {
  position: absolute;
  top: 0;
  right: 45px;
  transform: scale(0.5);
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/ChartKit/components/Loader/Loader.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,UAAA;AADJ;AAGI;EACI,2CAAA;AADR;AAKQ;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,qBAAA;AAHZ","sourcesContent":[".chartkit-loader {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n}\n.chartkit-loader_veil {\n  background-color: var(--ck-veil-background);\n}\n.chartkit-loader__loader_compact {\n  position: absolute;\n  top: 0;\n  right: 45px;\n  transform: scale(0.5);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
